import { SEARCH_CATEGORY_HANDLE_SEPARATOR, SEARCH_CATEGORY_QUERY_SEPARATOR } from '~/constants';

export const getEncodedCategoryHandle = (categoryHandle: string): string => {
  return encodeURIComponent(
    categoryHandle.split(SEARCH_CATEGORY_HANDLE_SEPARATOR).join(SEARCH_CATEGORY_QUERY_SEPARATOR),
  );
};
